import * as React from 'react';

import CareerOutcomesModule from 'bundles/unified-description-page-common/components/modules/career-outcomes/CareerOutcomesModule';
import CourseCareerOutcomesSubtitle from 'bundles/unified-description-page-common/components/modules/career-outcomes/CourseCareerOutcomesSubtitle';
import DataBox from 'bundles/unified-description-page-common/components/modules/career-outcomes/DataBox';
import type { ConsumerCoursePageFieldsFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/ConsumerCoursePageQuery';
import type { EnterpriseCoursePageFieldsFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/EnterpriseCoursePageQuery';
import {
  getCareerOutcomesTitleForCourse,
  getCareerOutcomesValuePropsForCourse,
} from 'bundles/unified-description-page-common/utils/careerOutcomes';
import { COURSE_NAV_ITEMS } from 'bundles/unified-description-page-common/utils/getPageNavigationLinks';

import careerOutcomesDataBoxImage from 'images/unified-description-page/career-outcomes-course.png';

type Props = {
  pageData: ConsumerCoursePageFieldsFragment | EnterpriseCoursePageFieldsFragment;
};

const CourseCareerOutcomesModuleRenderer = ({ pageData }: Props) => {
  if (!pageData.specializations || !pageData.specializations.length) {
    return null;
  }

  return (
    <CareerOutcomesModule
      anchorId={COURSE_NAV_ITEMS.OUTCOMES}
      title={getCareerOutcomesTitleForCourse(
        pageData.specializations,
        pageData.domains?.[0]?.subdomainName || pageData.domains?.[0]?.domainName
      )}
      subtitle={<CourseCareerOutcomesSubtitle specializations={pageData.specializations} />}
      valueProps={getCareerOutcomesValuePropsForCourse(pageData.specializations, pageData.partners?.[0]?.name)}
      dataBox={<DataBox imageSrc={careerOutcomesDataBoxImage} />}
    />
  );
};

export default CourseCareerOutcomesModuleRenderer;
